import React from 'react';
import { type RestVideoRowModal } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import SimpleModalTitle from './sections/simple-title';

type Props = Pick<RestVideoRowModal['requires'], 'info' | 'hero'> & {
  actions: React.ReactNode;
};
const VideoRow: React.FC<Props> = (props) => {
  const { info, hero, actions } = props;
  return (
    <div className="video-row">
      <SimpleModalTitle customStyles={{ paddingLeft: 30 }}>
        <CustomerHtml value={info.title} />
      </SimpleModalTitle>
      <div className="VRContainer">
        <div className="top-row">
          <div className="video-wrapper">
            <iframe
              title="watch-video"
              className="video-embed"
              src={hero.url}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        </div>
        <div className="bottom-row">
          <div className="detail-heading">{info.detail_heading}</div>
          <div className="details">
            <div className="detail-content">
              <CustomerHtml value={info.details} />
            </div>
            <div className="action">{actions}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoRow;
